import { Language } from "@/types/Language";

export const languageCodeMap: Partial<Record<Language, string>> = {
  de: "Deutsch",
  nl: "Nederlands", // Dutch
  fr: "Français", // French
  bg: "Bulgarian",
  hr: "Croatian",
  el: "Greek",
  cs: "Czech",
  da: "Danish",
  et: "Estonian",
  fi: "Suomen kieli",
  hu: "Hungarian",
  en: "English",
  it: "Italiano",
  is: "Icelandic",
  lv: "Latvian",
  lt: "Lithuanian",
  mt: "Malti",
  pl: "Polish",
  pt: "Portuguese",
  ro: "Romanian",
  sk: "Slovak",
  sl: "Slovene",
  es: "Spanish",
  sv: "Svenska",
  nb: "Norwegian",
  zh: "中文", // (zhōngwén) Chinese
  ar: "العربية" // Arabic
};
